<template>
  <el-dialog title="编辑订单组别" class="dialogClass" :visible.sync="dialogVisible" width="680px" :before-close="dialogBeforeClose">
      <div style="width: 100%;">
        <el-table :data="groupTableData" style="width: 100%" row-key="uuid" max-height="400px" stripe border v-loading="tableLoading">
            <el-table-column prop="prop" label="日期范围" min-width="240px" align="center">
              <template slot-scope="{row}">
                <span v-if="!row.editFlag" style="height: 32px;line-height: 32px;display: inline-block;" key="1">{{ `${row.startDate}-${row.endDate}` }}</span>
                <el-date-picker v-else key="2" style="width: 100%;" v-model="row.dateList" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期" type="daterange" size="small" placeholder="date"></el-date-picker>
              </template>
            </el-table-column>
            <el-table-column prop="prop" label="组别tag" min-width="180px" align="center">
              <template slot-scope="{row}">
                <span v-if="!row.editFlag" key="1" :class="row.editFlag?'tagText':''">{{ row.tag || '--' }}</span>
                <el-input v-else key="2" v-model="row.tagName" maxlength="10" size="small" placeholder="请输入tag"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150px" align="center">
              <template slot-scope="{row}">
                <el-button type="text" class="cloumnBtn" icon="el-icon-edit-outline" style="color: #599bf4;" v-if="!row.editFlag" @click="editRowGroup(row)" ></el-button>
                <el-button type="text" class="cloumnBtn" icon="el-icon-check" style="color: #599bf4;" v-if="row.editFlag" @click="editConfirm(row)" ></el-button>
                <el-button type="text" class="cloumnBtn" icon="el-icon-close" style="color: red;" v-if="row.editFlag" @click="cancelEdit(row)"></el-button>
              </template>
            </el-table-column>
        </el-table>
        <el-button type="primary" icon="el-icon-plus" style="background-color: #FF3973;color: white;width: 100%;height: 32px;padding: 5px 0;border: none;" @click="addRow">新增</el-button>
      </div>
      <div slot="footer">
          <el-button size="small" @click="dialogBeforeClose">取 消</el-button>
          <el-button size="small" style="background-color: #FF3973;color: white;border: none;"  @click="saveGroupListEvent">确 定</el-button>
      </div>
  </el-dialog>
</template>
<script>
import {jsUuid} from '@/utils/functions.js'
export default {
  data() {
    return {
      dialogVisible: false,
      groupTableData: [],
      tableLoading:false
    }
  },
  props: {
    contractCodes: {
      type: String,
      default:''
    }
  },
  methods: {
    jsUuid,
    dialogBeforeClose() {
      this.dialogVisible = false
      this.groupTableData = []
    },
    // 获取组别
    async getOrderTagList() {
      this.tableLoading = true
      const result = await this.fetch('/orderlite/contract/api/v4/contract/order-groups/page', {
        contractCodes:[this.contractCodes],
        pageNum: 1,
        pageSize: 99999,
      },'post')
      this.tableLoading = false
      if (result.code === 0) {
        this.groupTableData = result.data.list?.map(s => {
          return {
            ...s,
            uuid:s.code,
            editFlag:false
          }
        })
      } else {
        this.groupTableData = []
      }
    },
    // 编辑
    editRowGroup(row) {
      if (row.startDate && row.endDate) {

        // row.dateList = [row.startDate,row.endDate]
        this.$set(row,'dateList',[row.startDate,row.endDate])
        this.$set(row,'tagName',row.tag || '')
      }
      console.log(row)
      row.editFlag = true
    },
    // 编辑确认
    editConfirm(row) {
      if (row.dateList.length) {

        row.editFlag = false
        row.startDate = row.dateList[0]
        row.endDate = row.dateList[1]
        row.tag = row.tagName || ''
      } else {

        this.$message.warning('请将数据补充完整后再进行保存操作')

      }
    },
    // 取消编辑
    cancelEdit(row) {
      if (row.startDate && row.endDate) {
        row.editFlag = false
        row.dateList = []
        row.tagName = ''
      } else {

        this.groupTableData = this.groupTableData.filter(s => s.uuid !== row.uuid)
      }
    },
    // 新增组别
    addRow() {
      const code = this.jsUuid()
      const obj = {
        dateList: '',
        tagName:'',
        editFlag: true,
        contractCode:this.contractCodes,
        uuid:code,
      }
      this.groupTableData.push(obj)
    },
    // 保存组别
    saveGroupListEvent() {
      const length = this.groupTableData.filter(s => s.editFlag).length
      if (length !== 0) {
        this.$confirm('包含未保存的订单组别，请确认是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(res => {
          this.saveGroupList()
        })
      } else {

        this.saveGroupList()
      }

    },
    async saveGroupList() {
      const orderGroups = this.groupTableData.filter(s => !s.editFlag || s.code)
      const result = await this.fetch('/orderlite/contract/api/v4/contract/order-groups', {
        orderGroups
      }, 'post')
      if (result.code === 0) {
        this.$message.success('操作成功')
        this.dialogBeforeClose()
        this.$emit('confirmGroup')
      }
    },
    showVisiable() {
      this.dialogVisible = true
      this.getOrderTagList()
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-date-editor{
  border: 1px solid #DCDFE6;
}
::v-deep .el-dialog__body{
  padding: 15px 20px;
}
::v-deep .cloumnBtn{

  margin-left: 0;
  padding: 8px 12px;
}
::v-deep .cloumnBtn  i{
  font-size: 20px;

}
.tagText{
  background-color: #ecf5ff;
  border-color: #d9ecff;
  display: inline-block;
  height: 32px;
  padding: 0 10px;
  line-height: 30px;
  font-size: 12px;
  color: #409EFF;
  border-width: 1px;
  border-style: solid;
  border-radius: 4px;
  box-sizing: border-box;
  white-space: nowrap;
}
</style>
